import { useContext } from 'react';
import UserNotificationsContext from 'common/contexts/UserNotificationsContext';

export default function useUserNotificationsContext() {
  return useContext(UserNotificationsContext);
}
